import { useNavigate } from '@tanstack/react-router';

export function RedirectToRoot() {
  const navigate = useNavigate();
  navigate({ to: '/' });
  return '';
}
